module.exports = __webpack_public_path__ + "img/youtube.16537e1a.png";